import { render, staticRenderFns } from "./games-info.vue?vue&type=template&id=2353519c&"
import script from "./games-info.vue?vue&type=script&lang=js&"
export * from "./games-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports